import { createContext } from 'react';

export interface ThemeContextProps {
  theme: 'lodestar-light' | 'ursa-light';
}
export const ThemeContext = createContext<ThemeContextProps>({ theme: 'lodestar-light' });
